import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4A90E2', // Medium blue
    },
    secondary: {
      main: '#20B2AA', // Light sea green
    },
    background: {
      default: '#F0F8FF', // Alice blue - very light blue
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#4A90E2',
            },
            '&:hover fieldset': {
              borderColor: '#357ABD',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#20B2AA',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(90deg, #4A90E2 0%, #20B2AA 50%, #4682B4 100%)', // Blue to teal to medium blue
        },
      },
    },
  },
});

export default theme;